// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-s-regular {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
}

.body-m-regular {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
}

.header-4 {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
}

.header-6 {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  vertical-align: middle;
}

.body-m-bold{
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/typography.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".body-s-regular {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0;\n  vertical-align: middle;\n}\n\n.body-m-regular {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n\n.header-4 {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 100%;\n}\n\n.header-6 {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n  vertical-align: middle;\n}\n\n.body-m-bold{\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
